import axios from 'axios'
import React, { useRef, useState } from 'react'
import { v4 as UUIDV4 } from "uuid"
import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';

import ygLogo from "../images/yg_logo.png"
import planLogo from "../images/plan.png"
import CustomSpinner from '../components/CustomSpinner';
import { motion, AnimatePresence } from "motion/react"

function Login({ serverURL }) {
    const emailRef = useRef()
    const passwordRef = useRef()
    const resetEmailRef = useRef()


    const [user, setUser] = useState({})

    const [resetSuccess, setResetSuccess] = useState(null)

    const [showToast, setShowToast] = useState(false)
    const [toastTitle, setToastTitle] = useState("")
    const [toastType, setToastType] = useState("")
    const [toastMessage, setToastMessage] = useState("")


    const [forgotPasswordView, setForgotPasswordView] = useState(false)

    const [registerResults, setRegisterResults] = useState("")
    const [loginView, setLoginView] = useState(false);

    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/"
    }

    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }


    const loginNow = async (e) => {
        e.preventDefault()
        const query = {
            "email": emailRef.current.value,
            "password": passwordRef.current.value,
        }
        const findUserNow = await axios.post(serverURL + "/users/login", query);
        if (findUserNow.status === 200) {
            const uid = UUIDV4()

            // Offline Method
            setCookie("userTos", findUserNow.data.email, 30)
            setCookie("tokenTos", uid, 30)

            let user = getCookie("userTos");
            let token = getCookie("tokenTos");

            if (user != "" && token != "") {
                const saveUser = await axios.get(serverURL + "/storeUser/" + findUserNow.data.email + "/" + uid, { withCredentials: true });
                if (saveUser) {
                    console.log(saveUser.data)

                    window.location.href = "/app/Home"
                } else {
                    console.log(saveUser.data)
                }
            } else {
                console.log("cookies were not saved")
            }


            setShowToast(true)
            setToastTitle("Success")
            setToastType("success")
            setToastMessage("Login Successfull")




            // online Method
            // const saveUser = await axios.get(serverURL + "/storeUser/" + findUserNow.data.email + "/" + UUIDV4(), { withCredentials: true });
            // if (saveUser) {
            //     console.log(saveUser.data)
            //     setUser(findUserNow.data)

            //     window.location.href = "/dashboard"
            // } else {

            // }
        } else {
            console.log(findUserNow.data)

            setShowToast(true)
            setToastTitle("Error")
            setToastType("error")
            setToastMessage(findUserNow.data)
        }
    }

    const checkCookies = async () => {
        // ################### offline methods ###############################
        if (document.cookie && document.cookie.split(";").length > 1) {

            let globalUser = getCookie("userTos")
            let globalToken = getCookie("tokenTos")

            const checkValidCookies = await axios.post(serverURL + "/users/checkValidCookies", { "email": globalUser, "token": globalToken })
            if (checkValidCookies.status == 200) {
                console.log(checkValidCookies.data)
                window.location.href = "/app/Home"
            } else {
                console.log(checkValidCookies.data)
                setLoginView(true)
            }
        } else {
            setLoginView(true)
        }


        // ################### Online Methods #####################################
        // const getCookies = await axios.get(serverURL + "/getCookieUser", { withCredentials: true });
        // if (getCookies.status == 200) {
        //     let globalUser = getCookies.data.user;
        //     let globalToken = getCookies.data.token;

        //     const checkValidCookies = await axios.post(serverURL + "/users/checkValidCookies", { "email": globalUser, "token": globalToken })
        //     if (checkValidCookies.status == 200) {
        //         console.log(checkValidCookies.data)
        //         window.location.href = "/dashboard"
        //     } else {
        //         console.log(checkValidCookies.data)
        //         setLoginView(true)
        //     }
        // } else {
        //     setLoginView(true)
        // }
    }

    const sendOTPToResetPassword = async (e) => {
        e.preventDefault()

        const query = {
            "email": resetEmailRef.current.value,
            "newPass": UUIDV4().split("-")[4]
        }

        const sentResetPassword = await axios.post(serverURL + "/users/resetPassowrd", query)
        if (sentResetPassword.status === 200) {
            setResetSuccess(true)
            resetAllFields()

            // setTimeout(() => {
            //     setForgotPasswordView(false);
            // }, 3000)
        } else {
            console.log(sentResetPassword.data);
            setToastTitle("Error")
            setToastType("error")
            setToastMessage(sentResetPassword.data)
            setShowToast(true)
        }
    }

    const resetAllFields = () => {
        setToastTitle("")
        setToastType("")
        setToastMessage("")
        setShowToast(false)
    }


    useState(() => {
        checkCookies()
    }, [])

    return (
        <>
            <div className="vh-100 wh-100 d-flex align-items-center justify-content-center loginBanner">

                {
                    loginView ? <>
                        <div className='d-none w-100 d-xl-flex flex-column gap-5 bg-warning h-100 align-items-center justify-content-center' style={{ position: "relative" }}>
                            <motion.h1
                                initial={{ translateY: "100%", opacity: 0 }}
                                animate={{ translateY: "0%", opacity: 1 }}
                                exit={{ translateY: "100%", opacity: 0 }}
                                transition={{ duration: .6, delay: 0 }}
                                className='pb-2 text-light' style={{ textShadow: "0 0 3px rgba(0,0,0,0.4)" }}>
                                <div style={{ fontSize: "8rem" }} className='d-flex align-items-center justify-content-between'>

                                    <span>2</span>
                                    <span>0</span>
                                    <span>2</span>
                                    <span>5</span>
                                    <span>-</span>
                                    <span>2</span>
                                    <span>6</span>

                                </div>
                                <span className='display-1' style={{ fontWeight: "600" }}>Strategic Focus</span>
                            </motion.h1>
                            <ul style={{ fontWeight: "600" }}>
                                <motion.li initial={{ translateY: "100%", opacity: 0 }} animate={{ translateY: "0%", opacity: 1 }} exit={{ translateY: "100%", opacity: 0 }} transition={{ duration: 0.5, delay: 0.7 }} style={{ fontSize: "1.2rem" }}>Brand Repositioning and Expansion</motion.li>
                                <motion.li initial={{ translateY: "100%", opacity: 0 }} animate={{ translateY: "0%", opacity: 1 }} exit={{ translateY: "100%", opacity: 0 }} transition={{ duration: 0.5, delay: 0.8 }} style={{ fontSize: "1.2rem" }}>Key Performance Indicators (KPIs) for every department</motion.li>
                                <motion.li initial={{ translateY: "100%", opacity: 0 }} animate={{ translateY: "0%", opacity: 1 }} exit={{ translateY: "100%", opacity: 0 }} transition={{ duration: 0.5, delay: 0.9 }} style={{ fontSize: "1.2rem" }}>Process Efficiency</motion.li>
                                <ul>
                                    <motion.li initial={{ translateY: "100%", opacity: 0 }} animate={{ translateY: "0%", opacity: 1 }} exit={{ translateY: "100%", opacity: 0 }} transition={{ duration: 0.5, delay: 1 }} style={{ fontSize: "1.2rem" }}>Regular progress reviews through KRAs</motion.li>
                                </ul>
                                <motion.li initial={{ translateY: "100%", opacity: 0 }} animate={{ translateY: "0%", opacity: 1 }} exit={{ translateY: "100%", opacity: 0 }} transition={{ duration: 0.5, delay: 1.1 }} style={{ fontSize: "1.2rem" }}>Focus to Enhance all Stakeholders' Experience</motion.li>
                                <ul>
                                    <motion.li initial={{ translateY: "100%", opacity: 0 }} animate={{ translateY: "0%", opacity: 1 }} exit={{ translateY: "100%", opacity: 0 }} transition={{ duration: 0.5, delay: 1.2 }} style={{ fontSize: "1.2rem" }}>Customer – Happy customer</motion.li>
                                    <motion.li initial={{ translateY: "100%", opacity: 0 }} animate={{ translateY: "0%", opacity: 1 }} exit={{ translateY: "100%", opacity: 0 }} transition={{ duration: 0.5, delay: 1.3 }} style={{ fontSize: "1.2rem" }}>Employees – More celebrations</motion.li>
                                    <motion.li initial={{ translateY: "100%", opacity: 0 }} animate={{ translateY: "0%", opacity: 1 }} exit={{ translateY: "100%", opacity: 0 }} transition={{ duration: 0.5, delay: 1.4 }} style={{ fontSize: "1.2rem" }}>Partners – Leading towards growth</motion.li>
                                    <motion.li initial={{ translateY: "100%", opacity: 0 }} animate={{ translateY: "0%", opacity: 1 }} exit={{ translateY: "100%", opacity: 0 }} transition={{ duration: 0.5, delay: 1.5 }} style={{ fontSize: "1.2rem" }}>Parents – Satisfaction & enhanced experience</motion.li>
                                </ul>
                                <motion.li initial={{ translateY: "100%", opacity: 0 }} animate={{ translateY: "0%", opacity: 1 }} exit={{ translateY: "100%", opacity: 0 }} transition={{ duration: 0.5, delay: 1.6 }} style={{ fontSize: "1.2rem" }}>Leadership Development</motion.li>
                                <ul>
                                    <motion.li initial={{ translateY: "100%", opacity: 0 }} animate={{ translateY: "0%", opacity: 1 }} exit={{ translateY: "100%", opacity: 0 }} transition={{ duration: 0.5, delay: 1.7 }} style={{ fontSize: "1.2rem" }}>Build a strong second line of leadership</motion.li>
                                    <motion.li initial={{ translateY: "100%", opacity: 0 }} animate={{ translateY: "0%", opacity: 1 }} exit={{ translateY: "100%", opacity: 0 }} transition={{ duration: 0.5, delay: 1.8 }} style={{ fontSize: "1.2rem" }}>Build a culture of frank communication & trust</motion.li>
                                </ul>
                                <motion.li initial={{ translateY: "100%", opacity: 0 }} animate={{ translateY: "0%", opacity: 1 }} exit={{ translateY: "100%", opacity: 0 }} transition={{ duration: 0.5, delay: 1.9 }} style={{ fontSize: "1.2rem" }}>Employee Development & Retention</motion.li>
                                <motion.li initial={{ translateY: "100%", opacity: 0 }} animate={{ translateY: "0%", opacity: 1 }} exit={{ translateY: "100%", opacity: 0 }} transition={{ duration: 0.5, delay: 2 }} style={{ fontSize: "1.2rem" }}>Revenue Growth at all Levels</motion.li>
                                <motion.li initial={{ translateY: "100%", opacity: 0 }} animate={{ translateY: "0%", opacity: 1 }} exit={{ translateY: "100%", opacity: 0 }} transition={{ duration: 0.5, delay: 2.1 }} style={{ fontSize: "1.2rem" }}>Encourage Innovation</motion.li>
                                <ul>
                                    <motion.li initial={{ translateY: "100%", opacity: 0 }} animate={{ translateY: "0%", opacity: 1 }} exit={{ translateY: "100%", opacity: 0 }} transition={{ duration: 0.5, delay: 2.2 }} style={{ fontSize: "1.2rem" }}>Culture of innovation and self-initiative</motion.li>
                                    <motion.li initial={{ translateY: "100%", opacity: 0 }} animate={{ translateY: "0%", opacity: 1 }} exit={{ translateY: "100%", opacity: 0 }} transition={{ duration: 0.5, delay: 2.3 }} style={{ fontSize: "1.2rem" }}>Proactiveness</motion.li>
                                </ul>
                            </ul>

                            {/* <img src={planLogo} alt="" style={{ position: "absolute", width: "150px", right: "0", bottom: "300px", transform: "translateX(50%)" }} /> */}
                        </div>

                        <div className='h-100 w-100 d-flex flex-column align-items-center justify-content-between' style={{ maxWidth: "800px" }}>
                            <span></span>
                            <div className="d-flex align-items-center w-100 p-5 loginFormPanel">
                                <form action="" onSubmit={(e) => { loginNow(e) }} className='d-flex flex-column gap-3 w-100'>
                                    <div className='d-flex align-items-center justify-content-center gap-3 mb-3'>
                                        <img src={ygLogo} alt="" className='w-100' style={{ maxWidth: "50px" }} />
                                        <p className='fs-2 text-center formTitle m-0'>YG PORTAL</p>
                                    </div>
                                    <input type="email" className='inputFieldsCustom w-100' required placeholder='Email' ref={emailRef} />
                                    <input type="password" className='inputFieldsCustom w-100' required placeholder='Password' ref={passwordRef} />
                                    <button type="submit" className='loginButtonsCustom w-100'>Login</button>
                                    <div>
                                        <button type='button' className='btn text-dark p-1' onClick={() => { setForgotPasswordView(true); }}>Forgot Password?</button>
                                    </div>
                                    <div>
                                        {
                                            showToast ?
                                                <div className={`alert alert-${toastType === "error" ? "danger" : "success"} px-0 py-2 w-100 text-center`}>
                                                    {toastMessage}
                                                </div>
                                                :
                                                ""
                                        }
                                    </div>
                                </form>
                            </div>
                            <span className='copyright p-2'>Copyright © {new Date().getFullYear()} Yes Germany. All rights reserved.</span>
                        </div>
                    </>
                        :
                        <CustomSpinner size={1} />}

            </div>

            {/*############################## Edit User Start ###############################*/}
            <Modal
                show={forgotPasswordView}
                size='md'
                backdrop="static"
                onHide={() => { setForgotPasswordView(false); setResetSuccess(null); resetAllFields(); }}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <span className='themeTextColor'>
                            Forgot Password
                        </span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        !resetSuccess ?
                            <form action="" onSubmit={(e) => { sendOTPToResetPassword(e); }} className='d-flex flex-column align-items-center' >
                                <label htmlFor="emailReset" className='w-100 text-dark'>
                                    <p>Please enter the <span>Email Address</span> associated with your account.</p>
                                </label>
                                <div className='d-flex alert alert-light w-100'>
                                    <input type="email" id="emailReset" ref={resetEmailRef} required className='form-control w-100' placeholder='Email Address' />
                                    <input type="submit" className="btn btn-sm rouded-pill px-3 btn-success" value={"Reset Now"} />
                                </div>
                            </form>
                            :
                            <p className='alert alert-success py-3 text-center' >
                                Your new system generated password has been sent.
                            </p>
                    }
                </Modal.Body>
                <Modal.Footer>
                    {
                        showToast ?
                            <div className={`alert alert-${toastType === "error" ? "danger" : "success"} p-0 w-100 text-center`}>
                                {toastMessage}
                            </div>
                            :
                            ""
                    }
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default Login